module.exports = __webpack_public_path__ + "Ruka.png?ffa5387353a6452dc09ca6df17f6c216";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/Ruka.png
// module id = 82
// module chunks = 0